<template>
  <div class="flex flex-col justify-center h-full mx-16 mt-[20%] mb-64">
    <References v-if="isReceived && !isBasic && !hasNoApps" class="mx-auto" :width="75" :height="75" aria-hidden="true" />
    <h2 class="font-medium text-m1 mt-16">
      <span v-if="hasNoApps">No sitters have applied yet</span>
      <span v-else-if="isInterested && !isBasic">
        {{ isMobile ? 'Tap' : 'Click' }} the “I’m interested” button when viewing received applicants to move them to this tab
      </span>
      <span v-else-if="isInterested && isBasic"> Upgrade to Premium to move applicants to “Interested” tab </span>
      <span v-else-if="isNotAFit">
        {{ isMobile ? 'Tap' : 'Click' }} the “{{ isBasic ? 'mark as ' : '' }}not a fit” button when viewing received applicants to
        move them to this tab
      </span>
      <span v-else>You’ve responded to all your applicants</span>
    </h2>
    <Button
      variant="primary"
      class="w-full mt-16"
      :value="buttonText"
      size="medium"
      :to="buttonHref"
      @click="buttonText === 'View applicants' && goToTabIndex('RECEIVED')"
    />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import References from '@/graphics/illustrations/ReferencesIllustration.vue';

export default {
  name: 'ApplicationsEmptyState',
  components: { Button, References },
  inject: ['goToTabIndex'],
  props: {
    currentTab: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasNoApps(): boolean {
      return this.$store.getters['applications/allStatusTotal'] === 0;
    },
    isBasic(): boolean {
      return this.$store.getters['account/getAccount']?.isBasic() || false;
    },
    isReceived(): boolean {
      return this.currentTab === 'RECEIVED';
    },
    isInterested(): boolean {
      return this.currentTab === 'INTERESTED';
    },
    isNotAFit(): boolean {
      return this.currentTab === 'NOT_A_FIT';
    },
    isMobile(): boolean {
      return this.$store.getters['applications/isMobile']();
    },
    /* eslint-disable no-else-return */
    buttonText(): string {
      if (this.hasNoApps) {
        return 'Search sitters';
      } else if (this.isInterested) {
        return this.isBasic ? 'View Pricing' : 'View applicants';
      } else if (this.isNotAFit) {
        return 'View applicants';
      } else {
        return 'View messages';
      }
    },
    buttonHref(): string {
      if (this.hasNoApps) {
        return '/availability/search';
      } else if (this.isInterested) {
        return this.isBasic ? '/upgrade/pricing' : '';
      } else if (this.isNotAFit) {
        return '';
      } else {
        return '/messages';
      }
    },
    /* eslint-enable no-else-return */
  },
};
</script>
